import { Sites } from '@ps/platform-message-framework/common/Sites';
import classNames from 'clsx';
import React from 'react';
import { useSelector } from 'react-redux';

import { select } from '@swf/core/store';

import type { ImageFetchProps } from '../../model/types';

import styles from './BannerImage.scss';

interface BannerImageProps extends ImageFetchProps {
  image?: string;
  isCenterImage?: boolean;
}

const BannerImage: React.FC<BannerImageProps> = ({ image, priority, isCenterImage }) => {
  const site = useSelector(select.cms.getSiteId);
  const shouldCenterImage = site === Sites.FRA || isCenterImage;
  return image ? (
    <img
      className={classNames(styles.image, { [styles.centerImage]: shouldCenterImage })}
      src={image}
      alt=""
      loading={priority === 'high' ? 'eager' : 'lazy'}
      // eslint-disable-next-line react/no-unknown-property
      fetchPriority={priority}
    />
  ) : null;
};

export default BannerImage;
